import ActionTypes from '../constants/ActionTypes';
import api from '../constants/api';
import { authHeader, checkError } from '../helpers';
import { postApi } from '../helpers/http';

export const requestAccounts = date => ({
  type: ActionTypes.REQUEST_ACCOUNT,
  date
})

export const receiveAccounts = (params, json) => ({
  type: ActionTypes.RECEIVE_ACCOUNT,
  date: params.date,
  items: json.data,
  receivedAt: Date.now()
})

export const requestAccountsFail = (params, json) => ({
  type: ActionTypes.REQUEST_ACCOUNT_FAIL,
  items: json.data,
})

export const deletedAccount = (params, json) => ({
  type: ActionTypes.DELETE_ACCOUNT,
  deletedEmail: params.login_email,
})

export const deleteAccountFail = (params) => ({
  type: ActionTypes.DELETE_ACCOUNT_FAIL,
  deletedId: params.i_num,
})

export const closeAlertDeletedAccount = () => ({
  type: ActionTypes.CLOSE_ALERT_DELETE_ACCOUNT,
})

export const getAccountsService = async params => {
  const data = {
    "process_type": "getUserAccount",
    "user_id": params.user_id,
    "offset": params.offset,
    "limit": params.limit
  };
  
  return await postApi(data);
   
}

const doFetchAccounts = params => async dispatch => {
  dispatch(requestAccounts(params))

  const data = {
    "process_type": "getUserAccount",
    "keys": params.keys,
    "user_name": params.user_name,
    "section_name": params.section_name,
    "department_name": params.department_name,
    "offset": params.offset,
    "limit": params.limit
  };

  try {
    const json = await postApi(data);
    const editSuccess = checkError(json) === false;

    if (json.statusCode === 500) {
      dispatch(requestAccountsFail(params, json));
    } else if (editSuccess) {
      dispatch(receiveAccounts(params, json));
    };
  } catch (error){
    console.error('Error:', error);
  }

  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json())
  // .then(json => {
  //   // console.log('Success:', json);
  //   const editSuccess = checkError(json) === false;
  //   if (editSuccess) {
  //     dispatch(receiveAccounts(params, json))
  //   }
  // })
  // .catch((error) => {
  //   console.error('Error:', error);
  // });
}

const doDeleteAccount = params => async dispatch => {
  const data = {
    "process_type": "deleteUserAccount",
    "login_email": params.login_email 
  };

  try {
    const json = await postApi(data);
    const editSuccess = checkError(json) === false;

    if (editSuccess) {
      dispatch(deletedAccount(params, json))
    } else {
      dispatch(deleteAccountFail(params))
    }

    return json;

  } catch (error) {
    console.error('Error:', error);
  }
  
  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json())
  // .then(json => {
  //   // console.log('Success:', json.data);
  //   const editSuccess = checkError(json) === false;
  //   if (editSuccess) {
  //     dispatch(deletedAccount(params, json))
  //   } else {
  //     dispatch(deleteAccountFail(params))
  //   }
  // })
  // .catch((error) => {
  //   console.error('Error:', error);
  // });
}

export const fetchAccounts = params => (dispatch, getState) => {
  return dispatch(doFetchAccounts(params))
}

export const deleteAccount = params => (dispatch, getState) => {
  return dispatch(doDeleteAccount(params))
}

export const closeAlert = () => (dispatch) => {
  return dispatch(closeAlertDeletedAccount())
}
